'use client'

import React, {forwardRef, ReactNode, useState} from "react";
import {IMaskInput} from "react-imask";
import clsx from "clsx";
import {FlexFieldPropsType} from "../types";
import {FlexFieldStyle} from "../styles";

const FlexField = forwardRef<HTMLDivElement, FlexFieldPropsType>(({
                                                                      value,
                                                                      type,
                                                                      onChange,
                                                                      onFocus,
                                                                      onBlur,
                                                                      onClick,
                                                                      mask = /.*/,
                                                                      required = false,
                                                                      disabled = false,
                                                                      isError = false,
                                                                      placeholder,
                                                                      beforeElements,
                                                                      afterElements,
                                                                      textIcon,
                                                                      trashIcon,
                                                                      dropdownIcon,
                                                                      onTextIconClick,
                                                                      onTrashIconClick,
                                                                      onDropdownIconClick,
                                                                      notInput = false,
                                                                      className = FlexFieldStyle,
                                                                  }, ref): React.JSX.Element => {
    const [isFocus, setIsFocus] = useState<boolean>(false)

    const handleChange = (newValue: string) => {
        onChange && onChange(newValue)
    }

    const handleBlur = (e: any) => {
        onBlur && onBlur(e)
        setIsFocus(false)
    }

    const handleFocus = (e: any) => {
        onFocus && onFocus(e)
        setIsFocus(true)
    }

    const getTextIcon = (): ReactNode => {
        if (textIcon) {
            if (onTextIconClick) {
                return <button onClick={onTextIconClick}
                               disabled={disabled}
                               className={className?.textIcon}>{textIcon}</button>
            } else {
                return <div className={className?.textIcon}>{textIcon}</div>
            }
        }
        return undefined
    }

    const getTrashIcon = (): ReactNode => {
        if (trashIcon) {
            if (onTrashIconClick) {
                return <button disabled={disabled}
                               onClick={onTrashIconClick}
                               className={className?.trashIcon}>{trashIcon}</button>
            } else {
                return <div className={className?.trashIcon}>{trashIcon}</div>
            }
        }
        return undefined
    }

    const getDropdownIcon = (): ReactNode => {
        if (dropdownIcon) {
            if (onDropdownIconClick) {
                return <button disabled={disabled}
                               onClick={onDropdownIconClick}
                               className={className?.dropdownIcon}>{dropdownIcon}</button>
            } else {
                return <div className={className?.dropdownIcon}>{dropdownIcon}</div>
            }
        }
        return undefined
    }

    const getInput = () => {
        if (notInput) {
            return <span className={className?.inputField}>{value}</span>
        }

        let validValue = typeof value === 'string' ? value : ''
        return <IMaskInput value={validValue}
                           type={type}
                           mask={mask}
                           required={required}
                           disabled={disabled}
                           placeholder={placeholder}
                           onAccept={handleChange}
                           onFocus={handleFocus}
                           onBlur={handleBlur}
                           className={className?.inputField}/>
    }

    return (
        <div ref={ref}
             onClick={onClick}
             className={clsx(className?.flexField, {
                 [className?.isError as string]: isError,
                 [className?.disabled as string]: disabled,
                 [className?.focus as string]: isFocus,
                 [className?.pointer as string]: !!onClick,
             })}>
            {getTextIcon()}
            {beforeElements}
            {getInput()}
            {afterElements}
            {getTrashIcon()}
            {getDropdownIcon()}
        </div>
    )
})

export default FlexField